/* AdminPage auto-generated by npm run generator */
import { makeStyles, Theme, Typography } from "@material-ui/core"
import AdminPageTable from "components/molecules/AdminPageTable"
import { CsvButton } from "components/molecules/CsvButton"
import CreateOrg from "components/molecules/dialogs/CreateOrg"
import InviteQlarityAdmin from "components/molecules/dialogs/InviteQlarityAdmin"
import { observer } from "mobx-react"
import React from "react"
import { useCollectionSubscribe } from "hooks/useSnapshots"
import Store from "store/Store"

interface AdminPageProps {}

const useStyles = makeStyles((theme: Theme) => ({
    adminPagePage: {
        display: "grid",
        gridGap: theme.spacing(4),
    },
    header: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: theme.spacing(4),
        gridAutoColumns: "max-content",
    },
}))

const AdminPage: React.FC<AdminPageProps> = (props) => {
    const classes = useStyles()
    const clients = useCollectionSubscribe(Store.auth.clientCollection)
    return (
        <div className={classes.adminPagePage}>
            <div className={classes.header}>
                <Typography variant="h5" display="inline">
                    Organization List
                </Typography>
                <CreateOrg />
                <InviteQlarityAdmin />
                <CsvButton clients={clients} />
            </div>
            <AdminPageTable />
        </div>
    )
}

export default observer(AdminPage)
